import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { AdminUsersSuccessResponse } from "./api-response/AdminUsersSuccessResponse";
import { AdminUserSuccessResponse } from "./api-response/AdminUserSuccessResponse";
import { map } from "rxjs/operators";

export class ApiAdmin {
  constructor(private apiEndpoint: string) {}

  adminUsers(
    token: string,
    organization: string
  ): Observable<AdminUsersSuccessResponse> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/admin-users`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  getAdminUser(
    token: string,
    organization: string,
    id: number | string
  ): Observable<AdminUserSuccessResponse> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/admin-users/${id}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  insert(
    token: string,
    organization: string,
    data: any
  ): Observable<{ id: any }> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/admin-users`,
      method: "POST",
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  update(
    token: string,
    organization: string,
    data: any,
    id: string
  ): Observable<any> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/admin-users/${id}`,
      method: "PUT",
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  modifyRole(
    token: string,
    organization: string,
    userId: string | number,
    role: string,
    add: boolean
  ): Observable<any> {
    const action = add ? "grant" : "revoke";

    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/role/${action}`,
      method: "POST",
      body: { userId, role },
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  modifyOrgAccess(
    token: string,
    organization: string,
    organizationId: string,
    userId: string | number,
    add: boolean
  ): Observable<any> {
    const action = add ? "grant" : "revoke";

    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/security/org-access/${action}`,
      method: "POST",
      body: { userId, organizationId },
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }
}
